import axios from 'axios';
import {sessionManager} from "./sessionManager";

// API timeout configuration (30 seconds)
const API_TIMEOUT_MS = 30000;

// Configure axios default timeout
axios.defaults.timeout = API_TIMEOUT_MS;

async function getAll(url) {
    return await axios.get(url, { timeout: API_TIMEOUT_MS }).catch(catchError);
}

async function getSingle(url, payload) {
    return await axios.get(url, { ...payload, timeout: API_TIMEOUT_MS }).catch(catchError);
}

async function post(url, model) {
    return await axios.post(url, model, { timeout: API_TIMEOUT_MS }).catch(catchError);
}

async function put(url, model) {
    return await axios.put(url, model, { timeout: API_TIMEOUT_MS }).catch(catchError);
}

async function remove(url) {
    return await axios.delete(url, { timeout: API_TIMEOUT_MS }).catch(catchError);
}
 

export const axiosProvider = {
    getAll,
    getSingle,
    post,
    put,
    remove,
};

//request interceptor
axios.interceptors.request.use(
    function (config) {
        config.headers = {
            ...config.headers,
            'X-Session-ID': sessionManager.getSession()
        };
        return config;
    },
    function (error) {
        catchError(error);
    }
);

//response interceptor
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
)

function catchError(error) {
    // Handle timeout errors
    if (error.code === 'ECONNABORTED' || error.message && error.message.includes('timeout')) {
        console.error('API request timeout:', error.config?.url);
        return { error: 'timeout', message: 'Forespørselen tok for lang tid. Vennligst prøv igjen.' };
    }
    
    // Handle network errors
    if (error.message === 'Network Error' || !error.response) {
        console.error('Network error:', error.message);
        return { error: 'network_error', message: 'Kunne ikke koble til serveren. Sjekk internettforbindelsen din.' };
    }
    
    if (error && error.response) {
        const code = error.response.status
        const response = error.response.data
        const originalRequest = error.config;

        if (code === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            //logout
        }

        if (code === 500) {
            return { error: 'server_error', message: 'Noe gikk galt på serveren. Vennligst prøv igjen.' };
        }

        if (code === 401) {
            const errorMessage = response.data;
            return { error: 'unauthorized', message: errorMessage };
        }

        if (code === 408 || code === 504) {
            return { error: 'timeout', message: 'Forespørselen tok for lang tid. Vennligst prøv igjen.' };
        }

        try {
            const errorMessage = JSON.parse(response.data)[0].errorMessage;
            return { error: 'api_error', message: errorMessage };
        } catch (parseError) {
            return { error: 'unknown_error', message: 'En uventet feil oppstod.' };
        }
    }
    else {
        return { error: 'unknown_error', message: error.message || 'En uventet feil oppstod.' };
    }
}